"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlayerTimeout = void 0;
function getPlayerTimeout(player) {
    if (!player.time || !player.time.playing)
        return Infinity;
    return Date.parse(player.time.lastChange) + player.time.availableTime;
}
exports.getPlayerTimeout = getPlayerTimeout;
//# sourceMappingURL=PlayerTime.js.map